/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Winter_Unoccupied_SetpointInputs */



/**
* | output |
* | --- |
* | "Winter unoccupation setpoint" |
*
* @param {Winter_Unoccupied_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const winter_unoccupied_setpoint = /** @type {((inputs?: Winter_Unoccupied_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Winter_Unoccupied_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Winter unoccupation setpoint")
	return /** @type {LocalizedString} */ ("Consigne inoccupation hiver")
});